import {
  Autocomplete,
  Box,
  Button,
  Card,
  Container,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import { useFormik, Form, FormikProvider } from 'formik';
import { DeleteForever } from '@mui/icons-material';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Page from '../components/Page';
import PageHeader from '../components/smallComponents/PageHeader';

const AddTransaction = () => {
  const navigate = useNavigate();
  const [transactionTypes, setTransactionTypes] = useState([]);
  const [ledgers, setLedgers] = useState([]);
  const [projects, setProjects] = useState([]);

  const transactionSchema = Yup.object().shape({
    paymentMode: Yup.string().required('Payment Mode is required'),
  });

  const formik = useFormik({
    initialValues: {
      items: [
        {
          ledgerId: '',
          transactionCategory: '',
          transactionType: '',
          amount: '',
        },
      ],
      projectId: '',
      date: moment().format('YYYY-MM-DD'),
      paymentMode: '',
    },
    validationSchema: transactionSchema,
    onSubmit: async () => {
      console.log('values', values);
      try {
        let creditAmount = 0;
        let debitAmount = 0;
        values.items.forEach((item) => {
          if (item.transactionType === 'CREDIT') {
            creditAmount += parseFloat(item.amount);
          } else if (item.transactionType === 'DEBIT') {
            debitAmount += parseFloat(item.amount);
          }
        });
        if (creditAmount !== debitAmount) {
          toast.error("Credit and Debit Amount doesn't match");
          return;
        }
        if (creditAmount === 0 || debitAmount === 0) {
          toast.error("Credit and Debit Amount can't be 0");
          return;
        }
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/payment/journal`, {
          ...values,
        });
 
        console.log(res.data.data);
        toast.success(res.data.message);
        resetForm();
        navigate('/dashboard/accounts/transaction');
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
    },
  });

  const getTransactionTypes = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/transactionType/other/active`);
      console.log(res.data.data);
      setTransactionTypes(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getLedgers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/ledger/all/active`);
      console.log(res.data.data, 'ledgers');
      if (!res.data.isError) {
        setLedgers(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getProjects = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/project/list`);
      if (res.data.isError === false) {
        setProjects(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, resetForm } = formik;

  useEffect(() => {
    getTransactionTypes();
    getLedgers();
    getProjects();
  }, []);

  return (
    <Page title="Add Journal">
      <Container maxWidth="xl">
        <PageHeader title="Add Journal" />
        <Card>
          <Box m={2}>
            <FormikProvider value={formik}>
              <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      id="asynchronous-demo"
                      isOptionEqualToValue={(option, value) => option.name === value.name}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) => option.name === value.name}
                      options={projects}
                      onChange={(_, value) => {
                        if (value) {
                          formik.setFieldValue('projectId', value._id);
                        } else {
                          formik.setFieldValue('projectId', '');
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Project"
                          sx={{
                            minWidth: '250px',
                          }}
                          InputProps={{
                            ...params.InputProps,
                          }}
                          error={Boolean(touched.projectId && errors.projectId)}
                          helperText={touched.projectId && errors.projectId}
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <Stack direction={'column'}>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', lineHeight: '1.1' }}>
                              {option.name}
                            </Typography>
                          </Stack>
                        </li>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={3}>
                    <TextField
                      fullWidth
                      label="Date"
                      type="date"
                      sx={{
                        minWidth: '250px',
                      }}
                      InputLabelProps={{ shrink: true }}
                      {...getFieldProps('date')}
                      error={Boolean(touched.date && errors.date)}
                      helperText={touched.date && errors.date}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={3}>
                    <TextField
                      select
                      label="Payment Mode"
                      fullWidth
                      {...getFieldProps('paymentMode')}
                      error={Boolean(touched.paymentMode && errors.paymentMode)}
                      helperText={touched.paymentMode && errors.paymentMode}
                      required
                    >
                      ><MenuItem value="BANK_TRANSFER">BANK TRANSFER</MenuItem>
                      <MenuItem value="CASH">CASH</MenuItem>
                      <MenuItem value="CHEQUE">CHEQUE</MenuItem>
                      <MenuItem value="CARD">CARD</MenuItem>
                      <MenuItem value="OTHER">OTHER</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      borderRadius: '5px',
                    }}
                  >
                    <Stack>
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Ledger</TableCell>
                              {/* <TableCell>Transaction Category</TableCell> */}
                              <TableCell>Amount</TableCell>
                              <TableCell>Type</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {values.items.map((item, index) => (
                              <TableRow key={index}>
                                <TableCell>
                                  <Autocomplete
                                    fullWidth
                                    id="asynchronous-demo"
                                    isOptionEqualToValue={(option, value) => option.name === value.name}
                                    getOptionLabel={(option) => option.name}
                                    getOptionSelected={(option, value) => option.name === value.name}
                                    options={ledgers}
                                    onChange={(_, value) => {
                                      if (value) {
                                        const newItems = [...values.items];
                                        newItems[index] = {
                                          ...newItems[index],
                                          ledgerId: value._id,
                                        };
                                        formik.setFieldValue('items', newItems);
                                      }
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Ledger"
                                        InputProps={{
                                          ...params.InputProps,
                                        }}
                                      />
                                    )}
                                    renderOption={(props, option) => (
                                      <li {...props}>
                                        <Stack direction={'column'}>
                                          <Typography variant="body2" sx={{ fontWeight: 'bold', lineHeight: '1.1' }}>
                                            {option.name}
                                          </Typography>
                                        </Stack>
                                      </li>
                                    )}
                                  />
                                </TableCell>
                                {/* <TableCell>
                                  <TextField
                                    fullWidth
                                    select
                                    label="Transaction Category"
                                    placeholder="Transaction Category"
                                    onChange={(e) => {
                                      const newItems = [...values.items];
                                      newItems[index] = {
                                        ...newItems[index],
                                        transactionCategory: e.target.value,
                                      };
                                      formik.setFieldValue('items', newItems);
                                    }}
                                  >
                                    <MenuItem value="INCOME">Income</MenuItem>
                                    <MenuItem value="EXPENSE">Expense</MenuItem>
                                    <MenuItem value="JOURNAL">Journal</MenuItem>
                                  </TextField>
                                </TableCell> */}

                                <TableCell
                                  sx={{
                                    maxWidth: '120px',
                                  }}
                                >
                                  <TextField
                                    fullWidth
                                    label="Amount"
                                    placeholder="Amount"
                                    onChange={(e) => {
                                      const newItems = [...values.items];
                                      newItems[index] = {
                                        ...newItems[index],
                                        amount: e.target.value,
                                      };
                                      formik.setFieldValue('items', newItems);
                                    }}
                                  />
                                </TableCell>
                                <TableCell
                                  sx={{
                                    minWidth: '100px',
                                  }}
                                >
                                  <TextField
                                    fullWidth
                                    select
                                    label="Type"
                                    placeholder="Type"
                                    onChange={(e) => {
                                      const newItems = [...values.items];
                                      newItems[index] = {
                                        ...newItems[index],
                                        transactionType: e.target.value,
                                      };
                                      formik.setFieldValue('items', newItems);
                                    }}
                                  >
                                    <MenuItem value="CREDIT">Credit</MenuItem>
                                    <MenuItem value="DEBIT">Debit</MenuItem>
                                  </TextField>
                                </TableCell>
                                {index !== 0 && (
                                  <TableCell sx={{ width: '120px' }}>
                                    <IconButton
                                      onClick={() => {
                                        const newItems = [...values.items];
                                        newItems.splice(index, 1);
                                        formik.setFieldValue('items', newItems);
                                      }}
                                      variant="outlined"
                                      color="error"
                                    >
                                      <DeleteForever />
                                    </IconButton>
                                  </TableCell>
                                )}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <Stack sx={{ width: '100%' }} justifyContent={'flex-end'} direction={'row'} mt={1}>
                        <Button
                          variant="contained"
                          onClick={() => {
                            const newItems = [...values.items];
                            newItems.push({
                              ledgerId: '',
                              transactionName: 0,
                              transactionType: 0,
                              amount: 0,
                            });
                            formik.setFieldValue('items', newItems);
                          }}
                        >
                          Add Item
                        </Button>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
                <Stack p={5} direction={'row'} justifyContent={'flex-end'} spacing={4}>
                  <Button type="button" variant="contained" onClick={() => resetForm()}>
                    Reset
                  </Button>
                  <Button type="submit" variant="contained" disabled={isSubmitting}>
                    Submit
                  </Button>
                </Stack>
              </Form>
            </FormikProvider>
          </Box>
        </Card>
      </Container>
    </Page>
  );
};

export default AddTransaction;
